import {FormControl, FormGroup} from '@angular/forms';

import {AmsService, CompanySummaryInterface, EmailTemplateModel, MessageTemplateModel} from '@spa/api';
import {AutocompleteOptionInterface} from 'appShared/components';
import {BaseValidationFrom} from '../base-validation.form';

type ControlValueType = string | number | boolean | string[];

export abstract class BaseMessageTemplatesForm<ControlFormInterface> extends BaseValidationFrom<ControlFormInterface> {
    protected hasApprovePermission: boolean;
    public form: FormGroup;
    public controls: ControlFormInterface;

    constructor(
        protected readonly amsService: AmsService,
        protected readonly companies: CompanySummaryInterface[],
        public templateModel: EmailTemplateModel | MessageTemplateModel = null,
        protected readonly departments: string[],
    ) {
        super();
    }

    protected prepareFormValue(): void {
        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];

            if (this.templateModel) {
                control.value = this.getControlValue(control.name);
            }

            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }

    protected prepareCompaniesOptions(): AutocompleteOptionInterface[] {
        if (!this.companies || this.companies.length === 0) {
            return [];
        }

        return this.companies.map((item: CompanySummaryInterface): AutocompleteOptionInterface => {
            return {
                label: `${item.name}; ID ${item.id}`,
                value: item.id
            };
        });
    }

    public prepareDepartmentsOptions(): AutocompleteOptionInterface[] {
        if (!this.departments || this.departments.length === 0) {
            return [];
        }

        const tempDepartments: any = this.departments;

        return tempDepartments.departments.map((item: string): AutocompleteOptionInterface => {
            return {
                label: item,
                value: item,
            };
        });

    }

    abstract getControlValue(name: string): ControlValueType;

    abstract initForm(): void;
}
